exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#techPreconditionsRegister .v--modal-box.v--modal{min-height:350px!important;min-width:600px!important}#techPreconditionsRegister .modal__footer{display:none!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-66d0143c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/management/modals/TechnicalPreconditionsRegister.vue
// module id = 2215
// module chunks = 0